function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import { useKeyPress } from '../../hooks';
import Modal from '../modal';

var ProductTour = function ProductTour(_ref) {
  var arrow = _ref.arrow,
      arrowClassName = _ref.arrowClassName,
      attachTo = _ref.attachTo,
      children = _ref.children,
      className = _ref.className,
      closeable = _ref.closeable,
      decoration = _ref.decoration,
      decorationClassName = _ref.decorationClassName,
      decorationPlacement = _ref.decorationPlacement,
      onClose = _ref.onClose,
      others = _objectWithoutProperties(_ref, ["arrow", "arrowClassName", "attachTo", "children", "className", "closeable", "decoration", "decorationClassName", "decorationPlacement", "onClose"]);

  // the escape key should trigger the `onClose` prop, if set
  var pressedEscape = useKeyPress('Escape');
  useEffect(function () {
    if (closeable && pressedEscape && onClose) onClose(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressedEscape]); // handle the product tour position & disposition, and its target

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      target = _useState2[0],
      setTarget = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      timerId = _useState4[0],
      setTimerId = _useState4[1];

  var _useState5 = useState({
    position: 'fixed',
    top: 40,
    left: 'calc(50% - 175px)'
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      position = _useState6[0],
      setPosition = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      arrowDirection = _useState8[0],
      setArrowDirection = _useState8[1];

  var _useState9 = useState('ahead'),
      _useState10 = _slicedToArray(_useState9, 2),
      disposition = _useState10[0],
      setDisposition = _useState10[1];

  useEffect(function () {
    var update = function update() {
      if (!attachTo) return;

      var _target = document.querySelector(attachTo);

      setTarget(_target);
      if (!_target) return;
      handlePopinPosition(_target);
    };

    update(); // window.clearInterval(timerId)

    setTimerId(window.setInterval(update, 500));
    return function () {
      // stop the interval
      window.clearInterval(timerId);
      if (!target) return; // remove any product-tour related classes from the target node

      target.classList.remove('product-tour-target', 'product-tour-target-active');
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var active = className.includes('is-active');

  var handleTargetClasses = function handleTargetClasses() {
    if (!target) return; // make it the target of the product tour

    target.classList.add('product-tour-target'); // handle its active status

    if (active) {
      target.classList.add('product-tour-target-active'); // remove the active status of other targets in the DOM, thus ensuring unicity in active state

      Array.from(document.querySelectorAll('.product-tour-target')).filter(function (e) {
        return e !== target;
      }).forEach(function (e) {
        e.classList.remove('product-tour-target', 'product-tour-target-active');
      });
    } else {
      target.classList.remove('product-tour-target', 'product-tour-target-active');
    }
  };

  handleTargetClasses();

  var handlePopinPosition = function handlePopinPosition(target) {
    // compute dimensions
    var _target$getBoundingCl = target.getBoundingClientRect(),
        x = _target$getBoundingCl.x,
        y = _target$getBoundingCl.y,
        height = _target$getBoundingCl.height,
        width = _target$getBoundingCl.width;

    var X = x + window.pageXOffset;
    var Y = y + window.pageYOffset;
    var SCROLL_WIDTH = document.body.scrollWidth;
    var SCROLL_HEIGHT = document.body.scrollHeight;
    var POPIN_WIDTH = 350; // 35rem = 350px

    var POPIN_HEIGHT = 200; // TODO: make it dynamic

    var MINIMUM_MARGIN = 40; // anything less than 30px make it look bad

    var GAP = 10; // let's have a minimal margin gap between the popin and its target

    var isSpaceAvailableLeft = MINIMUM_MARGIN + POPIN_WIDTH <= X;
    var isSpaceAvailableRight = X + width + POPIN_WIDTH + MINIMUM_MARGIN <= SCROLL_WIDTH;
    var isSpaceAvailableTop = MINIMUM_MARGIN + POPIN_HEIGHT <= Y;
    var isSpaceAvailableBottom = Y + height + POPIN_HEIGHT + MINIMUM_MARGIN <= SCROLL_HEIGHT;
    var isSpaceAvailableAround = isSpaceAvailableLeft || isSpaceAvailableRight || isSpaceAvailableTop || isSpaceAvailableBottom;

    var _disposition = isSpaceAvailableAround ? 'around' : 'ahead';

    var _orientation;

    if (isSpaceAvailableAround) {
      switch (true) {
        case isSpaceAvailableLeft:
          _orientation = 'left';
          break;

        case isSpaceAvailableRight:
          _orientation = 'right';
          break;

        case isSpaceAvailableTop:
          _orientation = 'top';
          break;

        case isSpaceAvailableBottom:
          _orientation = 'bottom';
          break;
      }
    }

    setDisposition(_disposition); // setOrientation(_orientation)
    // compute the popin position

    var pos = {};
    var arrowDirection;

    if (_disposition === 'around') {
      switch (_orientation) {
        case 'left':
          pos.right = "calc(100% - ".concat(X - GAP, "px)");
          pos.top = Math.max(Y, MINIMUM_MARGIN);
          arrowDirection = 'right';
          break;

        case 'right':
          pos.left = X + width + GAP;
          pos.top = Math.max(Y, MINIMUM_MARGIN);
          arrowDirection = 'left';
          break;

        case 'top':
          pos.bottom = window.innerHeight - Y + GAP;
          pos.left = X;
          arrowDirection = 'bottom';
          break;

        case 'bottom':
          pos.top = Y + height + GAP;
          pos.left = X;
          arrowDirection = 'top';
          break;
      }
    } else {
      pos.position = 'fixed';
      pos.top = MINIMUM_MARGIN;
      pos.left = 'calc(50% - 175px)';
    }

    setPosition(pos);
    setArrowDirection(arrowDirection);
  };

  if (!position) return null;
  var classes = classNames('product-tour is-hidden-touch', className, "has-icon-".concat(decorationPlacement));
  var isArrow = typeof arrow !== 'undefined' || disposition === 'around';

  var _arrowClassName = classNames('arrow', arrowClassName, "is-".concat(arrow || arrowDirection), 'is-one-fifth');

  var isDecorativeImage = decoration && (decoration.substr(0, 1) === '/' || decoration.substr(0, 4) === 'http');
  var isDecorativeIcon = decoration && decoration.substr(0, 4) === 'tri-';
  var Tour = React.createElement(React.Fragment, null, React.createElement("div", _extends({
    className: classes
  }, others, {
    style: _objectSpread({}, position, {
      transition: 'all 0.15s ease-out'
    })
  }), isArrow && React.createElement("div", {
    className: _arrowClassName
  }), decoration && React.createElement("span", {
    className: classNames('icon', decorationClassName)
  }, isDecorativeImage && React.createElement("img", {
    src: decoration,
    className: "is-rounded"
  }), isDecorativeIcon && React.createElement("i", {
    className: "".concat(decoration, " is-rounded")
  })), closeable && React.createElement("button", {
    className: "icon close is-medium is-grey",
    onClick: function onClick(e) {
      return onClose(e);
    }
  }, React.createElement("i", {
    className: "tri-ui-times"
  })), React.createElement("div", {
    className: "product-tour-content"
  }, children)), React.createElement(Modal, _extends({
    "is-hidden-desktop": true,
    isActive: active
  }, others, {
    onClose: onClose
  }), children));
  if (!target) return Tour;
  return ReactDOM.createPortal(Tour, document.body);
};

ProductTour.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  attachTo: PropTypes.string,
  arrow: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  decoration: PropTypes.string,
  decorationPlacement: PropTypes.oneOf(['left', 'right']),
  decorationClassName: PropTypes.string,
  arrowClassName: PropTypes.string
};
ProductTour.defaultProps = {
  decorationPlacement: 'left'
};
export default withModifiers(ProductTour);